import EFPicture from '@elem/compCommon/EFPicture';
import css from './index.module.scss';

export default function PCCom({ title, imgArr, subtitle, desc, tips, hasTitleSvg, titleSvg }: any) {
    return (
        <div className={`pc-com ${css['pc-com']}`}>
            <h2 className="dp3-title">{title}</h2>
            <ul className="imgs">
                {imgArr?.map((item: any, k: number) => (
                    <li className={`img ${item?.title || item?.desc ? 'has-info' : ''}`} key={k}>
                        <div className="img-box">
                            <EFPicture src={item?.img} alt={item?.title || title} />
                        </div>
                        {(item?.title || item?.desc) && (
                            <div className="img-info">
                                <div className="inner">
                                    {hasTitleSvg && titleSvg}
                                    {item?.title && <p className="img-title">{item?.title}</p>}
                                    {item?.desc && <p className="img-desc">{item?.desc}</p>}
                                </div>
                            </div>
                        )}
                    </li>
                ))}
            </ul>
            <div className="info-box">
                <p className="subtitle">{subtitle}</p>
                <p className="desc">
                    {desc}
                    <span className="tips">{tips}</span>
                </p>
            </div>
        </div>
    );
}
